<nb-card>
  <nb-card-header> </nb-card-header>

  <nb-card-body>
    <div class="table-responsive">
      <ng2-smart-table
        [settings]="settings"
        [source]="source"
        (userRowSelect)="selectedProduct($event)"
      >
      </ng2-smart-table>
      <strong class="text-hint">Tổng số: {{ source.count() }}</strong>
    </div>
  </nb-card-body>
</nb-card>
